import { render, staticRenderFns } from "./EmbeddedMeetingSidebar.vue?vue&type=template&id=790552de&scoped=true"
import script from "./EmbeddedMeetingSidebar.vue?vue&type=script&lang=js"
export * from "./EmbeddedMeetingSidebar.vue?vue&type=script&lang=js"
import style0 from "./EmbeddedMeetingSidebar.vue?vue&type=style&index=0&id=790552de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790552de",
  null
  
)

export default component.exports